import { Injectable } from '@angular/core';
import { ApiResponseDefault } from '@core/interfaces/request-response/api.dto';
import {
  AgregarItemGestionTiempoReq,
  CrearGestionTiempoReq,
  EliminarItemsGestionTiempoReq,
  GestionTiempoRes,
} from '@core/interfaces/request-response/gestion-tiempo.dto.interface';
import { environment } from '@env/environment';
import { BaseHttpService } from '@shared/services/base-http.service';

@Injectable({
  providedIn: 'root',
})
export class GestionTiempoApiService extends BaseHttpService {
  crear(rq: CrearGestionTiempoReq) {
    return this.withLoader(
      this.httpClient.post<ApiResponseDefault>(
        `${environment.apiUrl}${environment.apiPreFix}/gestion-tiempo/crear`,
        rq,
      ),
    );
  }
  eliminar(gestion_tiempo_id: number) {
    return this.withLoader(
      this.httpClient.delete<ApiResponseDefault>(
        `${environment.apiUrl}${environment.apiPreFix}/gestion-tiempo/eliminar`,
        {
          body: { gestion_tiempo_id },
        },
      ),
    );
  }
  cargar() {
    return this.withLoader(
      this.httpClient.get<GestionTiempoRes[]>(
        `${environment.apiUrl}${environment.apiPreFix}/gestion-tiempo/cargar`,
      ),
    );
  }
  agregarItems(rq: AgregarItemGestionTiempoReq) {
    return this.withLoader(
      this.httpClient.post<ApiResponseDefault>(
        `${environment.apiUrl}${environment.apiPreFix}/gestion-tiempo/agregar-items`,
        rq,
      ),
    );
  }
  eliminarItems(rq: EliminarItemsGestionTiempoReq) {
    return this.withLoader(
      this.httpClient.delete<ApiResponseDefault>(
        `${environment.apiUrl}${environment.apiPreFix}/gestion-tiempo/eliminar-items`,
        {
          body: { ...rq },
        },
      ),
    );
  }
}
